"use client";

import type { CSSProperties } from "react";

function SkeletonBar({
  className,
  style,
}: {
  className: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`rounded bg-contrast/6 shimmer shimmer-bg text-foreground ${className}`}
      style={style}
    />
  );
}

export function HighlightsSkeleton() {
  return (
    <div className="flex flex-col gap-2.5 items-start px-4 sm:px-8 py-4 sm:py-6 w-full border-b border-border">
      <div className="flex items-center py-1.5 w-full">
        <SkeletonBar className="h-[18px] w-[100px]" />
      </div>
      {[1, 2, 3].map((n) => (
        <div
          key={n}
          className="flex flex-col gap-1.5 items-start overflow-hidden p-4 rounded-lg border border-border w-full"
        >
          <div className="flex items-center gap-1.5 w-full">
            <SkeletonBar className="size-4 !rounded shrink-0" />
            <SkeletonBar className="h-3.5 w-[120px]" />
          </div>
          <SkeletonBar className="h-[13px] w-[80%]" />
        </div>
      ))}
    </div>
  );
}
